module.exports = __webpack_public_path__ + "img/分隔星星.26d71ebd.svg";